import { SxProps, Theme } from "@mui/material";
import { TFunction } from "i18next";
import { Loader, Play, SquareCheck, X } from "lucide-react";
import React from "react";
import { BadgeBox } from "../Commons/BadgeBox";

export const getStatusBadge = (status: string, theme: Theme, t: TFunction, sx?: SxProps) => {
  const config: Record<string, {
    bg: string; border: string; color: string; icon: React.ReactNode; label: string
  }> = {
    APPROVED: {
      bg: theme.customColors.backgroundSecondaryAlternative,
      border: `1px solid ${theme.customColors.borderPrimaryCta}`,
      color: theme.customColors.textTag,
      icon: <SquareCheck size={ "0.875rem" } />,
      label: t("approved")
    },
    COMPLETED: {
      bg: theme.customColors.backgroundSecondaryComplete,
      border: `1px solid ${theme.customColors.borderSecondaryComplete}`,
      color: theme.customColors.textTag,
      icon: <SquareCheck size={ "0.875rem" } />,
      label: t("completed")
    },
    IN_PROGRESS: {
      bg: theme.customColors.backgroundSecondary,
      border: `1px solid ${theme.customColors.border}`,
      color: theme.customColors.textTag,
      icon: <Loader size={ "0.875rem" } />,
      label: t("in_progress")
    },
    PENDING: {
      bg: theme.customColors.backgroundWarning,
      border: `1px solid ${theme.customColors.borderWarning}`,
      color: theme.customColors.textTag,
      icon: <Loader size={ "0.875rem" } />,
      label: t("pending")
    },
    REJECTED: {
      bg: theme.customColors.backgroundError,
      border: `1px solid ${theme.customColors.borderError}`,
      color: theme.customColors.textTag,
      icon: <X size={ "0.875rem" } />,
      label: t("rejected")
    },
    TO_START: {
      bg: theme.customColors.backgroundError,
      border: `1px solid ${theme.customColors.borderError}`,
      color: theme.customColors.textTag,
      icon: <Play size={ "0.875rem" } />,
      label: t("to_start")
    }
  };

  const cfg = config[status] ?? config.PENDING;

  return (
    <BadgeBox
      background={ cfg.bg }
      border={ cfg.border }
      textColor={ cfg.color }
      sx={ sx }
    >
      <>
        { cfg.icon }
        <span>{ cfg.label }</span>
      </>
    </BadgeBox>
  );
};
